import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Model component with several configuration options. Can be extended and improved.
 * @param {Object} param0 | {footerButtons, body, title, visible, redirectPathOnClos, setUpdateStateTrigger, ...props}
 * @returns React Component
 */
export default function ConfirmModal({
  footerButtons = true,
  body,
  title,
  visible,
  // eslint-disable-next-line no-unused-vars
  redirectPathOnClose = false,
  setUpdateStateTrigger,
  ...props
}) {
  return (
    <Modal
      show={visible}
      onHide={() => {
        // eslint-disable-next-line no-unused-expressions
        setUpdateStateTrigger && setUpdateStateTrigger((prev) => prev + 1);
        props.setVisible(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      {footerButtons && (
        <Modal.Footer>
          <Button variant="secondary" onClick={() => props.setVisible(false)}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              props.setSendRequest({ uniqueId: props.uniqueId });
              props.setVisible(false);
            }}
          >
            Continue
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
